import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

const DynamicCarPopup = dynamic(() => import('./CarPopup'), {
  ssr: false,
});
type Props = {
  name;
  routes;
};

const RouteList: FunctionComponent<Props> = ({ name, routes }) => {
  return (
    <span className={`${styles.root}`}>
      <span className={`label ${styles['_label']}`}>{name}</span>
      <span className={styles['_routes']}>
        {routes?.map((val, key) => {
          const { content, slug, page } = val;

          if (!val.page || (val.page && val.active === true)) {
            if (content?.carInfo) {
              const data = content.carInfo;
              const priceList = content.pricelist;

              const priceFrom = priceList?.elements.reduce((prev, curr) => {
                return prev.price < curr.price ? prev : curr;
              });

              return (
                <Link
                  key={key}
                  as={`/${data.slug.current}`}
                  href={`/${data.slug.current}`}
                  legacyBehavior>
                  <span>
                    <DynamicCarPopup name={data.name} figure={data.figure} priceFrom={priceFrom} />
                  </span>
                </Link>
              );
            }

            if (val.carDummy) {
              const priceFrom = val.overridPrice;

              return (
                <Link key={key} href={`/${val.slug.current}`} legacyBehavior>
                  <span>
                    <DynamicCarPopup
                      name={val.overridTitle}
                      figure={val.overridImage}
                      priceFrom={priceFrom}
                      dummy={true}
                    />
                  </span>
                </Link>
              );
            }

            if (slug) {
              return (
                <Link key={key} href={`/${slug.current}`} legacyBehavior>
                  <div className={`route ${styles['_route']}`}>
                    <h3>{page.title}</h3>
                  </div>
                </Link>
              );
            }
          }
          return null;
        })}
      </span>
    </span>
  );
};

export default React.memo(RouteList);
